import React, { useCallback } from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';

import { useRegionalLink } from 'hooks/useRegionalLink';

import {
  DateTime,
  Icon,
  Table,
  Text
} from 'components/common/Elements/Elements';

import { filesTableConf } from '../../helpers/configurates';
import { underlineToSpace } from 'utils/common';

import classes from './SubTable.module.scss';
import { access, hasAccess, resources } from 'utils/permissions';

const SubTable = ({ row, mouseLeave, mouseEnter, dataSub }) => {
  const generateRegionalPath = useRegionalLink();

  const getFileName = name => {
    const fileName = name.split('/');
    return fileName[fileName.length - 1];
  };
  const hasAgentRolloutWriteAccess = hasAccess([
    resources.CS_AGENT_ROLLOUT,
    access.WRITE
  ]);

  const generateAgentRolloutPath = useCallback(
    buildId => {
      const basePath = `/cs/agent-rollout/${dataSub.platform}_${dataSub.version}`;
      const regionalPath = generateRegionalPath(basePath);

      // Parse the regional path to separate pathname and search
      const [pathname, search = ''] = regionalPath.split('?');

      return {
        pathname,
        search: search ? `?${search}` : '',
        state: {
          agent: dataSub,
          buildIds: [buildId]
        }
      };
    },
    [dataSub, generateRegionalPath]
  );

  return (
    <Table.Row className={classes.subTable_wrap}>
      <Table.Cell className={classes.resetCell}>
        <div
          style={{ height: `calc(50px + ${dataSub.files.length * 66}px)` }}
          className={classes.fixCell}
        >
          <div className={classes.headerDecor} />
          <Table className={classes.subTable}>
            <Table.Header>
              <Table.Row>
                {filesTableConf.map(({ field, title }, idx) => (
                  <Table.HeaderCell
                    key={field}
                    className={classes.subTable_header}
                    onMouseEnter={mouseEnter}
                    onMouseLeave={mouseLeave}
                    r={`r${idx + 10}`}
                    title={title}
                  />
                ))}
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {dataSub.files.map(fileItem => (
                <Table.Row
                  key={fileItem.buildId}
                  className={classes.subTable_row}
                >
                  <Table.Cell
                    className={cn(
                      classes.subTable_cell,
                      row === 'r10' && classes.hov
                    )}
                    isId
                    onMouseEnter={mouseEnter}
                  >
                    <Icon
                      icon="parentLine"
                      size="73px"
                      className={cn(classes.child, classes.child_l)}
                    />
                    <Icon
                      icon="parentS"
                      size="50px"
                      className={cn(classes.child, classes.child_s)}
                    />
                    <a href={fileItem.agentCdnUrl} className={classes.fileName}>
                      {getFileName(fileItem.objectKey)}
                    </a>
                  </Table.Cell>
                  <Table.Cell
                    className={cn(
                      classes.subTable_cell,
                      row === 'r11' && classes.hov
                    )}
                    onMouseEnter={mouseEnter}
                  >
                    {fileItem.osDist}
                    <Text type="s" className={classes.arch}>
                      &nbsp;
                      {fileItem.arch}
                    </Text>
                  </Table.Cell>
                  <Table.Cell
                    className={cn(
                      classes.subTable_cell,
                      row === 'r12' && classes.hov
                    )}
                    onMouseEnter={mouseEnter}
                  >
                    {fileItem.contentLength}
                  </Table.Cell>
                  <Table.Cell
                    className={cn(
                      classes.subTable_cell,
                      row === 'r13' && classes.hov
                    )}
                    onMouseEnter={mouseEnter}
                  >
                    {underlineToSpace(fileItem.status)}
                  </Table.Cell>
                  <Table.Cell
                    className={cn(
                      classes.subTable_cell,
                      row === 'r14' && classes.hov
                    )}
                    onMouseEnter={mouseEnter}
                  >
                    <DateTime date={fileItem.createdAt} time />
                  </Table.Cell>
                  <Table.Cell
                    className={cn(
                      classes.subTable_cell,
                      row === 'r15' && classes.hov
                    )}
                    onMouseEnter={mouseEnter}
                  >
                    <DateTime date={fileItem.createdAt} time />
                  </Table.Cell>
                  <Table.Cell
                    className={cn(
                      classes.subTable_cell,
                      row === 'r16' && classes.hov
                    )}
                    onMouseEnter={mouseEnter}
                  >
                    {dataSub.platform === 'linux' &&
                      hasAgentRolloutWriteAccess && (
                        <NavLink
                          className={classes.linkSelect}
                          to={generateAgentRolloutPath(fileItem.buildId)}
                        >
                          Select
                        </NavLink>
                      )}
                  </Table.Cell>
                </Table.Row>
              ))}
            </Table.Body>
          </Table>
        </div>
      </Table.Cell>
    </Table.Row>
  );
};

SubTable.propTypes = {
  row: PropTypes.string,
  mouseLeave: PropTypes.func,
  mouseEnter: PropTypes.func,
  dataSub: PropTypes.object.isRequired
};

export default SubTable;
